import common from './common'
import debugHelper from '../../util/debug'
import audioText from '../../util/baidu_tts_cors'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import msgbus from '../../msgBus'
import dbHelper from '../../util/db'
import functions from '../../functions'


var JPush = {
  /**
   * 初始化JPush
   * @param {*} vm
   * @param {*} funcList
   */
  funcInitJPush: function (vm, funcList) {
    if (vm == null) {
      return
    }

    debugHelper.log('funcInitJPush: 初始化JPush')

    //browser平台的话, 不需要极光推送
    if (vm.getPlatform() == 'browser') {
      common.callNextFunc(vm, funcList)
      return
    }

    //初始化
    window.JPush.init()

    //设置Debug模式
    window.JPush.setDebugMode(true)

    //获取服务器端返回的唯一ID
    window.JPush.getRegistrationID(function (rId) {
      debugHelper.log('jpush' + rId)
    })

    common.callNextFunc(vm, funcList)
  },

  /**
   * 设置JPush别名
   * @param {*} vm
   * @param {*} funcList
   */
  funcSetJPushAlias: function (vm, funcList) {
    debugHelper.log('funcSetJPushAlias: 设置JPush别名')

    //browser平台的话, 不需要极光推送
    if (vm.getPlatform() == 'browser') {
      common.callNextFunc(vm, funcList)
      return
    }

    /*
            设置别名->用户姓名

            参数说明
                sequence: number。用户自定义的操作序列号, 同操作结果一起返回，用来标识一次操作的唯一性。
                alias: string
            每次调用设置有效的别名将覆盖之前的设置。
            有效的别名组成：字母（区分大小写）、数字、下划线、汉字、特殊字符@!#$&*+=.|。
            限制：alias 命名长度限制为 40 字节（判断长度需采用 UTF-8 编码）。
        */

    function init() {
      window.JPush.setAlias(
        {
          sequence: 1,
          alias: vm.getAccountID()
        },
        result => {
          var sequence = result.sequence
          var alias = result.alias
          debugHelper.log(result)
        },
        error => {
          var sequence = error.sequence
          var errorCode = error.code
          init()
        }
      )
    }

    init()

    common.callNextFunc(vm, funcList)
  },

  /**
   * 删除JPush别名
   * @param {*} vm
   * @param {*} funcList
   */
  funcDeleteJPushAlias: function (vm, funcList) {
    debugHelper.log('funcDeleteJPushAlias: 删除JPush别名')

    //browser平台的话, 不需要极光推送
    if (vm.getPlatform() == 'browser') {
      common.callNextFunc(vm, funcList)
      return
    }

    /*
            删除别名

            参数说明
                sequence: number。用户自定义的操作序列号, 同操作结果一起返回，用来标识一次操作的唯一性。
        */

    function init() {
      window.JPush.deleteAlias(
        {
          sequence: 1
        },
        result => {
          var sequence = result.sequence
          var alias = result.alias
          debugHelper.log(result)
        },
        error => {
          var sequence = error.sequence
          var errorCode = error.code
          init()
        }
      )
    }

    init()

    common.callNextFunc(vm, funcList)
  },

  /**
   * 设置JPush标签
   * @param {*} vm
   * @param {*} funcList
   */
  funcSetJPushTags: function (vm, funcList) {
    debugHelper.log('funcSetJPushTags: 设置JPush标签')

    //browser平台的话, 不需要极光推送
    if (vm.getPlatform() == 'browser') {
      common.callNextFunc(vm, funcList)
      return
    }

    /**
     设置标签->用户角色

     参数说明
     sequence: number。用户自定义的操作序列号, 同操作结果一起返回，用来标识一次操作的唯一性。
     tags: Array，标签数组。
     */
    function init() {
      var tags = []
      tags.push(vm.getAccountID())
      window.JPush.setTags(
        { sequence: 2, tags: tags },
        result => {
          debugHelper.log(result.tags)
          var sequence = result.sequence
          var alias = result.alias
        },
        error => {
          var sequence = error.sequence
          var errorCode = error.code
          init()
        }
      )
    }

    init()
    common.callNextFunc(vm, funcList)
  },

  /**
   * 设置安卓JPush收到通知的回调函数
   * @param {*} vm
   * @param {*} funcList
   */
  funcSetRecieveNotificationInAndroidCallback: function (vm, funcList) {
    debugHelper.log(
      'funcSetRecieveNotificationInAndroidCallback: 设置安卓JPush收到消息的回调函数'
    )

    //browser平台的话, 不需要极光推送
    if (vm.getPlatform() == 'browser') {
      common.callNextFunc(vm, funcList)
      return
    }

    var receiveNotificationInAndroidCallback =
      funcList[0].params.receiveNotificationInAndroidCallback

    //Android端 设置收到通知时候的回调函数
    window.plugins.jPushPlugin.receiveNotificationInAndroidCallback = data => {
      debugHelper.log(
        'receiveNotificationInAndroidCallback: 收到通知调用回调函数'
      )
      debugHelper.log(data)
    }

    common.callNextFunc(vm, funcList)
  },

  /**
   * 设置安卓JPush收到消息的回调函数
   * @param {*} vm
   * @param {*} funcList
   */
  funcSetRecieveMessageInAndroidCallback: function (vm, funcList) {
    debugHelper.log(
      'funcSetRecieveMessageInAndroidCallback: 设置安卓JPush收到消息的回调函数'
    )

    //browser平台的话, 不需要极光推送
    if (vm.getPlatform() == 'browser') {
      common.callNextFunc(vm, funcList)
      return
    }

    var receiveMessageInAndroidCallback =
      funcList[0].params.receiveMessageInAndroidCallback

    //Android端 设置收到消息时候的回调函数
    window.plugins.jPushPlugin.receiveMessageInAndroidCallback = data => {
      debugHelper.log('receiveMessageInAndroidCallback: 收到消息调用回调函数')
      debugHelper.log(data)
      if (data.extras.type == 'text_voice') {
        audioText({
          token: vm.getTTSToken(),
          text: data.message
        })
      }

      // 设置未读消息状态
      functions.msgbox.funcFetchMsgForBoxBadge(vm)
    }

    common.callNextFunc(vm, funcList)
  },

  /**
   * 设置安卓JPush打开消息的回调函数
   * @param {*} vm
   * @param {*} funcList
   */
  funcOpenNotificationInAndroidCallback: function (vm, funcList) {
    debugHelper.log(
      'funcOpenNotificationInAndroidCallback: 设置安卓JPush打开消息的回调函数'
    )

    //browser平台的话, 不需要极光推送
    if (vm.getPlatform() == 'browser') {
      common.callNextFunc(vm, funcList)
      return
    }

    var openNotificationInAndroidCallback =
      funcList[0].params.openNotificationInAndroidCallback

    //Android端 打开消息时候的回调函数
    window.plugins.jPushPlugin.openNotificationInAndroidCallback = data => {
      debugHelper.log('openNotificationInAndroidCallback: 打开消息调用回调函数')
      /*
            try {
                debugHelper.log(data)
                debugHelper.log("清除角标")
                vm.$emit("openOrder")
            } catch (exception) {
                debugHelper.log("JPushPlugin:pushCallback ", exception);
            }*/
      //openNotificationInAndroidCallback(data)
    }

    common.callNextFunc(vm, funcList)
  },
}

export default JPush
